module.exports = __webpack_public_path__ + "static/media/bos-logo.ce31fa87.png";